import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <>
      <div className="footer_container">
        <p>
          &copy; 2025 Accenture. All Rights Reserved. Accenture Confidential.
          For internal use only. 
        </p>
      </div>
    </>
  );
}

export default Footer;
